/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unresolved */
import { Box } from "@mui/material";
import OktaSignIn from "@okta/okta-signin-widget";

import { Fragment, useEffect, useRef } from "react";

import "@okta/okta-signin-widget/css/okta-sign-in.min.css";
// Replace your old imports with direct relative paths to node_modulesimport esLabel from '../../../../node_modules/@okta/okta-signin-widget/dist/labels/json/login_cs.json';

import styles from "./OktaSignInWidget.styles";

import { oktaLocalization } from "./oktaServices";
import { clearValuesOnSignIn } from "src/utils/loginHelper";
import { languages } from "src/constants/i18nConstants";
// eslint-disable-next-line import/no-unresolved
import i18n from "src/i18n";

export const OktaSignInWidget = ({ config, onSuccess, onError }) => {
    const widgetRef = useRef();
    useEffect(() => {
        //This is to clear the storage if user closes tab without logout
        clearValuesOnSignIn();
    }, []);

    useEffect(() => {
        if (!widgetRef.current) {
            return false;
        }
        const { esLabel, frLabel, brLabel, csLabel, deLabel, enLabel, frCaLabel, mxLabel, nlLabel, ukLabel } =
            oktaLocalization();
        const widget = new OktaSignIn({
            ...config,
            i18n: {
                [languages.en_us]: enLabel,
                [languages.cs]: csLabel,
                [languages.de]: deLabel,
                [languages.en_gb]: ukLabel,
                [languages.es]: esLabel,
                [languages.es_419]: mxLabel,
                [languages.fr_CA]: frCaLabel,
                [languages.fr_FR]: frLabel,
                [languages.nl]: nlLabel,
                [languages.pt_BR]: brLabel,
            },
            language: i18n?.language ? i18n?.language : languages.en_us,
        });
        widget
            .showSignInToGetTokens({
                el: widgetRef.current,
            })
            .then(onSuccess)
            .catch(onError);

        return () => widget.remove();
    }, [config, onSuccess, onError, i18n?.language]);

    return (
        <Box sx={styles.oktaContainer} className="oktaContainer">
            <Fragment>
                <div ref={widgetRef} />
            </Fragment>
        </Box>
    );
};
